import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      menu: {
        home: "Home",
        buycrypto: "Exchange",
        market: "Market",
        backlog: "Total Supply",
        pages: "Pages",
        sub: {
          userProfile: "User Profile",
          login: "Login",
          register: "Register",
          contact: "Contact",
          faq: "FAQ",
        },
      },
      faq: {
        faq1: {
          title: "How does Changebit exchange service operate?",
          text: "We work 24/7.",
        },
        faq2: {
          title: "How to submit exchange?",
          text: "Create exchange: Select the exchange direction (e.g. I give column - Bitcoin, I receive column - Ethereum). When you specify the amount to exchange or receive, the amount exchanged or received is automatically calculated. Please enter the details (card number or account number) you would like to receive payment below. For various payment methods, the system may request additional data. After clicking the redeem button, you will be redirected to a confirmation page. Copy the details and transfer the specified amount to our details. Check all data carefully. Then return to our website and confirm your payment by clicking the I paid button. Get ready. Please wait for your funds to arrive.",
        },
        faq3: {
          title: "How long does it take to process my exchange?",
          text: "The exchange is carried out by the operator in manual mode and takes on average between 3 and 60 minutes after receipt of payment, depending on the details of the application. Also, the exchange rate depends on the workload of the operator.",
        },
        faq4: {
          title: "Is the exchange rate fixed?",
          text: "Yes, the exchange rate for all payment directions is fixed at 30 minutes. If the user does not confirm payment after this time, the application will be in the Canceled state.",
        },
        faq5: {
          title:
            "What happens if I pay less or more than what is stated on my application?",
          text: "You will need to contact support to resolve this issue.",
        },
        faq6: {
          title:
            "I paid the application fee, but the money was not deposited into my account. What's the reason?",
          text: "The reasons may vary. Please make sure you have done everything correctly to successfully complete the exchange. The first reason is that you have not confirmed your payment. Please note that if you do not click the 'I paid' button, your application status will not change and your application will not be processed. Please make sure you have entered your transfer details (wallet, account, card) correctly. If payment cannot be made using the details specified, your application will receive a Canceled status and a note will appear below explaining the reason for cancellation. Please make sure the amount you sent matches the amount stated on your application. The accumulated amount may be less than the reported amount as payment system or bank fees cannot be taken into account. be careful! If your payment amount is different from the amount stated on your application, your application will receive a Canceled status. In this case, please contact the support team on our website and we will answer you what to do next. Please make sure you have made the payment correctly according to our details. If payment is not made to our account, your application will receive a Canceled status. Changing the address of the clipboard now occurs more frequently. Copy the address and after a while the address that the scammer uses to make payments will be stored in the buffer. So please make sure to double-check the recipient address at the end. Once you have found a replacement product, you should check your computer for viruses and do not use that computer to make payments until the virus problem has been resolved. If you transfer with incorrect information, we will not be able to assist you. Verify that funds have been withdrawn from your account. If the receipt is not confirmed, your application will be cancelled. There may be delays in transferring funds from your payment system or bank. In this case, you cannot speed up the process, you can only wait. You can call or write to find out the reason for the delay. Support your payment system or bank. When paying with cryptocurrency, please carefully check the address, network used and take into account other reviews of our system. If you make a mistake online, you won't be sending money to us, you'll be sending money to nowhere, and we won't be able to help you. All reasons are personal. So, if your reason is not one of the above, you can: Please write to us for assistance.",
        },
        faq7: {
          title:
            "The application status has changed to 'completed', but the payment amount is not reflected. What should I do?",
          text: "There may be delays in transferring funds from your payment system or bank. In this case, you cannot speed up the process, you can only wait. You can call or write to find out the reason for the delay. Support your payment system or bank. Sending cryptocurrency also takes time. On average, registration requires 3 to 6 network verifications. For more information, you can check which service your Bitcoin wallet is using. Confirmation speed depends on network load and commission size. If you set your fees too low, your transfer may take hours or longer.",
        },
        faq8: {
          title: "Can I cancel my application?",
          text: "All applications created on the site remain intact and will not be deleted. You can only change the state. There are only 4 states in the system: New - Only the user has created the application, but the user has not confirmed payment. Confirming - The user has confirmed payment for the application and is waiting. Completed for confirmation and execution by management – The application enters this state after the actual exchange is complete. This means that funds will be distributed based on your details. Canceled – If the exchange cannot be executed due to incorrect details or any other reasons, your application will be transferred to this status by the website administration. Additionally, apps in the 'New' state automatically transition to this state after 30 minutes. After completing the application, you will be taken to the application confirmation page. The payment deadline is 30 minutes, and you can cancel your application by clicking the Cancel Application button. Additionally, if no action is taken within 30 minutes, the application will be automatically canceled. Of course, you cannot cancel a completed application.",
        },
        faq9: {
          title: "Are there any additional currency exchange fees?",
          text: "All fees are included in the exchange rate. We pay fees for the payment system. You can check the actual amount received.",
        },
        faq10: {
          title: "How many times can I repay per day?",
          text: "No restrictions.",
        },
      },
      dataServices: {
        dataServices1: {
          title: "Manage Crypto Market",
          text: "Withdraw on card popular digital currencies and manage them effortlessly in one place.",
        },
        dataServices2: {
          title: "Enhanced Secure Transactions",
          text: "Safeguard your assets with our reinforced confidential protection, allowing you to transact with confidence through our secure and fast withdrawal process",
        },
        dataServices3: {
          title: "Trade on the Go",
          text: "Trade anytime, anywhere. Enjoy fast withdrawals with no registration required, getting you into the market or bank acount in just a few clicks.",
        },
      },
      terms: {
        term1: {
          title: "1. Right to Participate",
          text: [
            "1.1. You agree and acknowledge the following. You have reached the legal age to accept this Terms of Use. You have not been suspended or prohibited from using the service before.",
            "1.2. If you use the service on behalf of a corporation, you also state and guarantee the following. That entity is duly registered and acts according to its current laws. It is in the jurisdiction of corporate establishment and has granted you the authority to act on its behalf.",
          ],
        },
        term2: {
          title: "2. Terms and Definitions",
          text: [
            "2.1. Changebit is a trademark of a system that provides users with the ability to exchange digital currencies.",
            "2.2. Service - a system providing Internet services for the exchange, sale and purchase of digital and/or electronic money",
            "2.3. User is an individual who uses the Changebit service.",
            "2.4. Digital currencies - Bitcoin, Litecoin, Ethereum and other blockchain-based currencies.",
            "2.5. The Payment System is a software and hardware product developed by third parties representing: a mechanism for accounting for monetary obligations and organizing mutual agreements by users.",
            "2.6. Services - support for buying, selling and conducting peer-to-peer transactions. Information about digital currency exchanges and other services is published in the service window.",
            "2.7. Payment is the transfer of digital currency or fiat funds from the User to the User or the Service and in the opposite direction.",
            "2.8. Application - written and indicated intention of the User to use one of the services provided by the Service in electronic form through the Service website in accordance with the conditions described in the Agreement and specified in the parameters of this Appendix.",
            "2.9. Partner is a person who provides services to the Service to attract users, the terms of which are as follows. In this Agreement.",
          ],
        },
        term3: {
          title: "3. Rules for using your account on the Changebit website",
          text: [
            "3.1. The Changebit Site is for personal use only. By registering on the Site, you agree not to: Use an account other than your own and attempt to obtain an unauthorized account. Accessing another user's account. ",
            "3.2. Changebit management has the right to further verify and request the information provided. Required documents for exchange: Passport Photo or other identity card Bank card (without indication of confidential data) Current phone number for funds transfer Receipt and other necessary data. Voice Authentication is also possible (linked to your current phone number via phone or accessible messenger). If the conditions for submitting documents are not met, we reserve the right to refuse service. We will stop providing the service and initiate a refund to the sender's account information. The return process may take up to 5 business days.",
            "3.3. The Changebit service reserves the right to suspend transactions and hold the user's funds to prevent fraud, conduct that may result in financial or reputational loss to the service or the user for the required period of time, conduct financial investigations, and conduct financial investigations and conduct financial investigations on the payment gateway or To obtain transaction data from the issuer's bank.",
            "3.4. Confidentiality of your account. You acknowledge that you are responsible for complying with these strict rules: keeping your account information, including your password, confidential and protecting your digital currency; and all activities and transactions posted on your account. You understand that whatever compromises you may make, your login information may expose your account to unauthorized access by third parties, which may result in the loss of digital currency from your account, including linked accounts such as linked bank accounts. or loss or theft of funds.",
            "3.5. Liability to Third Parties Your Account is for personal use only and may not be misused or accessed by third parties. In any event, you will be solely responsible for any acts or omissions in your Account. Third parties accessing and/or using .",
            "3.6. You agree that you will not use the Services to engage in any criminal activity, including but not limited to, money laundering, illegal gambling, or terrorist financing. You further warrant that you will not use any method .To hide where you access the Site.",
          ],
        },
        term4: {
          title: "4. Services provided on the Changebit website",
          text: [
            "4.1. Ordering Changebit services is carried out by the User transmitting the corresponding application via the Changebit Internet site",
            "4.2. By using the Service, the User confirms that he or she is in legal possession and control of the banknotes, electronic and/or digital currency associated with such payment.",
            "4.3. The Changebit service provides the following services: A service that provides users with the opportunity to sell electronic and/or digital or fiat currency to other users in real time. Exchange of electronic and digital currency between users A service that provides the opportunity to exchange electronic and digital currencies between customers and the internal reserves of the exchange service.",
            "4.4. By filling out the application, the User instructs and the Service will perform actions on behalf of the User at the User's expense for the sale and transfer of digital and/or electronic goods or fiat currency to another User. ",
            "4.5. From the moment of receipt of funds from the User and during the time allotted in accordance with the Rules (depending on the direction of exchange), the amount specified in the relevant provisions of the Application, the Service shall exchange the received electronic or fiat currency in the data and amount specified by the User in the Application. We are obliged to transfer (transfer) to force majeure circumstances.",
            "4.6. The Service reserves the right to cancel applications created by the User for digital and/or electronic or fiat purchases if payment for such applications has not been made. It will be received in your current account.",
            "4.7. The obligation of the Service to transfer (transfer) received digital and/or electronic or fiat currency to the User is considered fulfilled at the time of withdrawal from the applicable payment system of the Service account entered in the transaction history of the relevant payment system. of digital and/or electronic or fiat currency.",
          ],
        },
        term5: {
          title: "5. User Responsibilities:",
          text: [
            "5.1. The User is responsible for the accuracy and completeness of the information and data provided during registration. If the User entered personal information incorrectly, provided incorrect data to run the application, or the Changebit service may We are not responsible for any losses incurred.",
            "5.2. By agreeing to these conditions, the User honestly declares and confirms the following:",
            "5.3. He provided accurate and truthful information about himself.",
            "5.4. They are not involved in any money laundering transactions or activities.",
            "5.5. His income is not related to criminal and/or terrorist activities",
            "5.6. His income is not related to any other illegal activities",
            "5.7. The User undertakes not to interfere with the operation of the Changebit Service by interfering with the software or hardware or distorting the parameters transmitted to the Service.",
            "5.8. The User shall not be liable for any partial or total failure to comply with these Terms and Conditions due to force majeure or unforeseen events or which could have been prevented by taking appropriate measures.",
          ],
        },
        term6: {
          title: "6. Final rules",
          text: [
            "6.1. The Changebit Service reserves the right to unilaterally change the Agreement by posting changes on the Service website. Changes will take effect from that moment, unless a different effective date for the changes is further determined at the time of posting. one.",
            "6.2. Changebit has the right to send information about the status of the exchange process and other information to the User via the email specified by the User.",
            "6.3. The information contained on the Site, including all graphics, text information, program code, etc., is the property of Changebit and is protected by copyright law.",
            "6.4. You confirm that you are familiar with all the provisions of these Terms and Conditions and fully accept them.",
          ],
        },
      },
      dataCryptoTab: {
        dataCryptoTab1: {
          title: "Submit the Exchange",
        },
        dataCryptoTab2: {
          title: "Payment Confirmation",
        },
        dataCryptoTab3: {
          title: "Exchange Details",
        },
      },
      productLink: {
        productLink1: {
          title: "Main Page",
        },
        productLink2: {
          title: "Market",
        },
        productLink3: {
          title: "Exchange",
        },
        productLink4: {
          title: "Total Supply",
        },
        productLink5: {
          title: "FAQ",
        },
      },
      servicesLink: {
        servicesLink1: {
          title: "Register",
        },
        servicesLink2: {
          title: "Login",
        },
        servicesLink3: {
          title: "Privacy Policy",
        },
        servicesLink4: {
          title: "Terms & Conditions",
        },
      },
      dataCoinTab: {
        dataCoinTab1: {
          title: "User Profile",
        },
        dataCoinTab2: {
          title: "Referrals",
        },
        dataCoinTab3: {
          title: "Transactions",
        },
        dataCoinTab4: {
          title: "Change password",
        },
      },
      dataAbout: {
        dataAbout1: {
          title: "Anonymity",
          text: "Maintain your privacy with Changebit. Transaction details and hashes are sent via email, ensuring visibility only to the client and preserving the confidentiality of your trades.",
        },
        dataAbout2: {
          title: "Confidence",
          text: "Trade with assurance at Changebit. We offer competitive price rates, ensuring you get value for your transactions. Our market data is consistently up-to-date, providing reliable information for your trading decisions.",
        },
        dataAbout3: {
          title: "Community",
          text: "We are committed to supporting the crypto community, ensuring that crucial data and information are accessible to those who need it most.",
        },
      },
      dataWork: {
        dataWork1: {
          step: "Step 1",
          title: "Go to the Exchange page",
          text: "Click right here ☝️",
        },
        dataWork2: {
          step: "Step 2",
          title: "Submit the Exchange",
          text: "Fill all fields on the form. Pay attention to network of your address",
        },
        dataWork3: {
          step: "Step 3",
          title: "Send funds to the address",
          text: "Click on qr code and send assets to the exchange address. Pay attention to network as well.",
        },
        dataWork4: {
          step: "Step 4",
          title: "Get the amount!",
          text: "Once we get the payment, we immediately send the currency to your wallet. Get all the details!",
        },
      },
      dataPrivacy: {
        dataPrivacy1: {
          title: "1. Information You Give Us:",
          text: "We receive and store any information you enter on our web site or give us in any other way. You can choose not to provide certain information, but then you might not be able to take advantage of many of our features. We use the information that you provide for such purposes as responding to your requests, customising future shopping for you, improving our store, and communicating with you.",
        },
        dataPrivacy2: {
          title: "2. Automatic Information:",
          text: "We receive and store certain types of information whenever you interact with us. For example, like many web sites, we use cookies and we obtain certain types of information when your web browser accesses Changebit. Scroll to the bottom of this page to see examples of the information we receive. A number of companies offer utilities designed to help you visit web sites anonymously. Although we will not be able to provide you with a personalised experience at Changebit if we cannot recognise you, we want you to be aware that these tools exist.",
        },
        dataPrivacy3: {
          title: "3. What About Cookies?",
          text: "Examples of the information we collect and analyse include the Internet Protocol (IP) address used to connect your computer to the Internet; login; e-mail address; password; computer and connection information such as browser type and version, operating system, and platform; purchase history; the full Uniform Resource Locators (URL) clickstream to, through, and from our Web site, including date and time; cookie number; and products you viewed or searched for.",
        },
        dataPrivacy4: {
          title: "4. E-mail Communications:",
          text: "To help us make e-mails more useful and interesting, we often receive a confirmation when you open e-mail from Changebit if your computer supports such capabilities. If you do not want to receive e-mail or other mail from us, please adjust your account to reflect this by selecting Unsubscribe in the Newsletter menu.",
        },
        dataPrivacy5: {
          title: "5. Does Changebit Share the Information It Receives?",
          text: "Information about our customers is an important part of our business, and we are not in the business of selling it to others.",
        },
      },
      termsofuse: "Terms of Use",
      termsofuse2: "Terms and Regulations",
      ter: "Terms",
      faqH: "FAQ",
      freqass: "Frequently Asked Questions",
      howItWork: "How It Work",
      howworks: "Learn how it works",
      selectCurrency: "Select currency",
      confirmPayment: "Payment Confirmation",
      invoice: "Invoice",
      sale1: "Register and participate daily $20 lottery",
      sale2:
        "Every day, one registered user who made transactions will be randomly chosen and will receive an additional $20 in their transaction.",
      createAccount: "Create Account",
      submitExchange: "Submit the Exhcange",
      pay: "Pay",
      receive: "Receive",
      amountToSend: "Amount to Send",
      amountToReceive: "Amount to Be Received",
      email: "Email",
      address: "Address",
      network: "Network",
      termsOfService: "Terms of Service",
      termsAccept: "I have read and accept the",
      continue1: "Continue",
      exchange: "Exchange",
      pages: "Pages",
      talk: "Let's talk!",
      exAddress:
        "Jungangbeonyeong-ro 20beona-gil Busanjin-gu, Busan, South Korea",
      newsletter: "Newsletter",
      newsletterDesc:
        "Subscribe our newsletter to get fresh news and updates about our service",
      enterEmail: "Enter your email",
      submitButton: "Submit",
      makePayment: "Make a payment",
      send: "Send",
      paymentDetails: "Payment Details",
      transactionUID: "Transaction ID",
      receiverAddress: "Reciever address",
      fromCur: "From Currency",
      toCur: "To Currency",
      clientEmail: "Client Email",
      cancel: "Cancel",
      allRights: "All rights reserved.",
      success: "Success",
      canceled: "Canceled",
      processing: "Processing",
      txError:
        "Error has occurred, if you sent the money, please contact our support",
      txProcess: "We are about to send",
      txSuccess: "You successfully bought",
      status: "Status",
      delivered: "Delivered",
      totalSupply: "Total Supply",
      overview: "Overview",
      indexFearGreed: "Crypto Fear and Greed Index",
      fear: "Fear",
      greed: "Greed",
      todayIndex: "Today Index",
      loadMore: "Load More",
      blog: "Latest News",
      blogDesc: "Check out the latest news from crypto world",
      totalBalance: "Total Balance",
      showBalance: "Show Balance",
      asset: "Asset",
      inOrders: "In Orders",
      availableTrade: "Available for Trade",
      login: "Login",
      loginTo: "Login to Changebit",
      welcomeBack: "Welcome back!",
      placeholderEmail: "Please fill in the email.",
      password: "Password",
      placeholderPassword: "Please enter a password.",
      placeholderCPassword: "Please re-enter your password.",
      rememberMe: "Remember Me",
      forgotPass: "Forgot Password?",
      notMember: "Not a member?",
      register: "Register",
      registerTo: "Register on Changebit",
      registerDesc: "Register in advance and enjoy the event benefits",
      username: "Username",
      placeholderUsername: "Enter username",
      country: "Country",
      countries: "Countries",
      countrySelect: "Select a country",
      phone: "Phone Number",
      placeholderPhone: "continue 01012345678 (without Country Code '+82')",
      haveAccount: "Already have an account?",
      userProfile: "User Profile",
      info: "Information",
      profileUpdate: "Update Profile",
      comingSoon: "Coming soon...",
      changePassword: "Change Password",
      newPassword: "New Password",
      oldPassword: "Old Passworld",
      placeholderOldPassword: "Please enter your old password.",
      placeholderNewPassword: "Please enter your new Password",
      confirmPassword: "Confirm Passworld",
      sold: "Sold",
      buy: "Buy",
      time: "Time",
      fullName: "Full name",
      contact: "Contact",
      leaveMessage: "Leave a message for us",
      getInTouch: "Get in touch with Changebit",
      yourName: "Your Name",
      yourNamePlaceholder: "Enter your name",
      message: "Message",
      messagePlaceholder: "Enter your message",
      sendMessage: "Send message",
      profile: "Profile",
      logout: "Logout",
      bannerHead: "Trade Fast, Securely & Anonymously.",
      bannerDesc:
        "Experience fast, reliable crypto transactions with Changebit. Join the secure exchange revolution!",
      exchangeNow: "Exchange now",
      sectionHead: "Your Trusted Crypto Trading Partner.",
      sectionDesc:
        "Discover the ease of trading with Cryptolly, where innovative features meet unparalleled reliability.",
      aboutHead: "Experience Reliable Crypto Trading",
      aboutDesc:
        "Join us for a simplified and secure trading experience, ensuring your journey in the crypto world is smooth and rewarding.",
      tradingPairs: "Trading Pairs",
      transactions: "Transactions",
      workDesc: "4 Easy steps to get started!",
      latestTransactions: "Latest Transactions",
      trade: "Trade",
      privacyHead: "Privacy Policy",
      privacyDesc:
        "Changebit knows that you care how information about you is used and shared, and we appreciate your trust that we will do so carefully and sensibly. This notice describes our Privacy Policy. By visiting Changebit, you are accepting the practices described in this Privacy Notice.",
    },
  },
  kr: {
    translation: {
      trade: "거래",
      latestTransactions: "최신 거래",
      howItWork: "작동 원리",
      workDesc: "4 시작하기 쉬운 단계!",
      termsofuse: "이용 약관",
      termsofuse2: "이용 약관",
      ter: "자귀",
      faqH: "자주 묻는 질문",
      freqass: "자주 묻는 질문",
      howworks: "작동 방법 알아보기",
      selectCurrency: "통화 선택",
      confirmPayment: "지불 확인서",
      invoice: "송장",
      sale1: "매일 $20 복권에 등록하고 참여하세요",
      sale2:
        "매일 거래를 한 등록 사용자 한 명이 무작위로 선택되며 거래에서 추가로 $20를 받게 됩니다.",
      createAccount: "계정 만들기",
      submitExchange: "교환 제출",
      pay: "지불하다",
      receive: "받다",
      amountToSend: "보낼 금액",
      amountToReceive: "받을 금액",
      email: "이메일",
      address: "주소",
      network: "회로망",
      termsAccept: "서비스 약관을 읽었으며 이에 동의합니다.",
      termsOfService: "서비스 약관",
      continue1: "계속하다",
      exchange: "교환",
      pages: "페이지",
      talk: "얘기하자!",
      exAddress: "중앙번영로20번나길 Busanjin-gu, Busan, South Korea",
      newsletter: "뉴스레터",
      newsletterDesc:
        "뉴스레터를 구독하시면 서비스에 대한 새로운 소식과 업데이트를 받아보실 수 있습니다.",
      enterEmail: "이메일을 입력하세요",
      submitButton: "제출",
      makePayment: "지불하다",
      send: "보내다",
      paymentDetails: "지불 세부 사항",
      transactionUID: "거래 ID",
      receiverAddress: "수신자 주소",
      fromCur: "통화에서",
      toCur: "통화로",
      clientEmail: "클라이언트 이메일",
      cancel: "취소",
      allRights: "판권 소유.",
      success: "성공",
      delivered: "배달됨",
      canceled: "취소 된",
      processing: "처리",
      txError: "오류가 발생했습니다. 돈을 보낸 경우 지원팀에 문의하세요.",
      txProcess: "보내드릴 예정입니다",
      txSuccess: "성공적으로 구매했습니다",
      status: "상태",
      totalSupply: "총 공급량",
      overview: "개요",
      indexFearGreed: "암호화폐 공포 및 탐욕 지수",
      fear: "두려움",
      greed: "탐욕",
      todayIndex: "오늘의 지수",
      loadMore: "더 로드하세요",
      blog: "최근 뉴스",
      blogDesc: "암호화폐 세계의 최신 소식을 확인하세요",
      totalBalance: "전체 균형",
      showBalance: "잔액 표시",
      asset: "유산",
      inOrders: "주문에",
      availableTrade: "거래 가능",
      login: "로그인",
      loginTo: "Changebit에 로그인",
      welcomeBack: "돌아온 것을 환영합니다!",
      placeholderEmail: "이메일을 작성해주세요.",
      password: "비밀번호",
      placeholderPassword: "비밀번호를 입력해주세요.",
      rememberMe: "날 기억해",
      forgotPass: "비밀번호를 잊으 셨나요?",
      notMember: "회원이 아니신가요?",
      register: "등록하다",
      registerTo: "Changebit에 등록하세요",
      registerDesc: "사전등록하고 이벤트 혜택을 누려보세요",
      placeholderCPassword: "비밀번호를 다시 입력해주세요.",
      placeholderUsername: "사용자 이름을 입력하세요",
      country: "국가",
      countries: "국가",
      transactions: "업무",
      tradingPairs: "거래쌍",
      countrySelect: "국가를 고르시 오",
      username: "사용자 이름",
      phone: "전화 번호",
      placeholderPhone: "계속 01012345678(국가 코드 '+82' 제외)",
      haveAccount: "이미 계정이 있나요?",
      userProfile: "유저 프로필",
      profileUpdate: "프로필 업데이트",
      comingSoon: "곧...",
      changePassword: "비밀번호 변경",
      newPassword: "새 비밀번호",
      oldPassword: "기존 비밀번호",
      placeholderOldPassword: "이전 비밀번호를 입력하세요.",
      placeholderNewPassword: "새로운 비밀번호를 입력해주세요",
      info: "정보",
      confirmPassword: "비밀번호 확인",
      sold: "판매된",
      buy: "구입하다",
      time: "시간",
      fullName: "전체 이름",
      contact: "연락하다",
      leaveMessage: "우리에게 메시지를 남겨주세요",
      getInTouch: "Changebit에 문의하세요",
      yourName: "당신의 이름",
      yourNamePlaceholder: "당신의 이름을 입력",
      message: "메시지",
      messagePlaceholder: "메시지를 입력하세요",
      sendMessage: "문자 보내",
      profile: "프로필",
      logout: "로그 아웃",
      bannerHead: "빠르고 안전하며 익명으로 거래하세요.",
      bannerDesc:
        "Changebit로 빠르고 안정적인 암호화폐 거래를 경험해보세요. 안전한 거래소 혁명에 동참하세요!",
      sectionHead: "귀하의 신뢰할 수 있는 암호화폐 거래 파트너.",
      sectionDesc:
        "혁신적인 기능과 비교할 수 없는 신뢰성이 만나는 Changebit를 통해 거래의 용이성을 느껴보세요.",
      exchangeNow: "지금 교환하세요",
      aboutHead: "믿을 수 있는 암호화폐 거래를 경험해 보세요",
      aboutDesc:
        "간편하고 안전한 거래 경험을 위해 우리와 함께 하세요. 암호화폐 세계에서의 여정이 원활하고 보람찬 것입니다.",
      privacyHead: "개인 정보 정책",
      privacyDesc:
        "Changebit는 귀하가 귀하에 관한 정보를 사용하고 공유하는 방식에 관심을 갖고 있다는 것을 알고 있으며, 우리가 신중하고 현명하게 이를 수행할 것이라는 귀하의 신뢰에 감사드립니다. 본 공지는 당사의 개인정보 보호정책을 설명합니다. Changebit를 방문함으로써 귀하는 본 개인정보 취급방침에 설명된 관행을 수락하게 됩니다.",
      menu: {
        home: "홈",
        buycrypto: "교환",
        market: "시장",
        backlog: "총 공급량",
        pages: "페이지",
        sub: {
          userProfile: "사용자 프로필",
          login: "로그인",
          register: "등록",
          contact: "문의",
          faq: "자주 묻는 질문",
        },
      },
      faq: {
        faq1: {
          title: "Changebit 교환 서비스는 어떤 모드로 운영되나요?",
          text: "우리는 연중무휴로 일하고 있습니다",
        },
        faq2: {
          title: "교환 제출 방법",
          text: "교환 생성: 교환 방향을 선택합니다(예: I give 열 - Bitcoin, I receive 열 - Ethereum). 교환 또는 수령할 금액을 지정하면, 주고받은 금액이 자동으로 계산됩니다. 아래에 지급받고자 하는 세부정보(카드번호 또는 계좌번호)를 입력하세요. 다양한 결제 방법의 경우 시스템에서 추가 데이터를 요청할 수 있습니다. 교환 버튼을 클릭하면 확인 페이지로 리디렉션됩니다. 세부 사항을 복사하고 지정된 금액을 우리의 세부 사항으로 이체하십시오. 모든 데이터를 주의 깊게 확인하세요. 그런 다음 당사 웹사이트로 돌아가서 결제했습니다 버튼을 클릭하여 결제를 확인하세요. 준비해. 자금이 도착할 때까지 기다리십시오.",
        },
        faq3: {
          title: "교환을 처리하는 데 얼마나 걸리나요?",
          text: "교환은 운영자가 수동 모드로 수행하며, 신청서의 세부 사항에 따라 결제 접수 후 평균 3~60분 정도 소요됩니다. 또한 환율은 운영자의 업무량에 따라 달라집니다.",
        },
        faq4: {
          title: "환율은 고정되어 있나요?",
          text: "네, 모든 결제 방향에 대한 환율은 30분으로 고정되어 있습니다. 이 시간 이후에도 사용자가 결제를 확인하지 않으면 애플리케이션은 취소됨 상태가 됩니다.",
        },
        faq5: {
          title:
            "신청서에 명시된 금액보다 적게 또는 많이 지불하면 어떻게 되나요?",
          text: "이 문제를 해결하려면 지원팀에 문의해야 합니다.",
        },
        faq6: {
          title:
            "신청비를 지불했지만 내 계좌로 돈이 입금되지 않았습니다. 이유는 무엇입니까?",
          text: "이유는 다양할 수 있습니다. 교환을 성공적으로 완료하려면 모든 작업을 올바르게 수행했는지 확인하십시오. 첫 번째 이유는 지불을 확인하지 않았기 때문입니다. '결제했습니다' 버튼을 누르지 않으시면 신청 상태가 변경되지 않으며, 신청이 처리되지 않으니 주의하시기 바랍니다. 송금 세부정보(지갑, 계좌, 카드)를 올바르게 입력했는지 확인하세요. 지정된 세부정보를 사용하여 결제할 수 없는 경우, 귀하의 애플리케이션은 취소됨 상태를 받게 되며 아래에 취소 이유를 설명하는 메모가 표시됩니다. 보낸 금액이 신청서에 명시된 금액과 일치하는지 확인하세요. 결제 시스템이나 은행의 수수료를 고려할 수 없어 적립된 금액이 신고된 금액보다 적을 수도 있습니다. 조심하세요! 결제 금액이 신청서에 명시된 금액과 다른 경우 신청서는 취소됨 상태를 받게 됩니다. 이 경우 당사 웹사이트의 지원팀에 문의해 주시면 다음에 수행해야 할 조치에 대해 답변해 드리겠습니다. 당사의 세부정보에 따라 올바르게 결제하셨는지 확인하세요. 당사 계정으로 결제가 이루어지지 않으면 귀하의 신청서는 취소됨 상태를 받게 됩니다. 이제 클립보드의 주소를 바꾸는 일이 더 자주 발생합니다. 주소를 복사하면 잠시 후 사기꾼이 지불하는 데 사용하는 주소가 버퍼에 저장됩니다. 그러니 마지막에 수취인 주소를 꼭 다시 확인해 주세요. 대체 제품을 찾으면 컴퓨터에 바이러스가 있는지 확인해야 하며 바이러스 문제가 해결될 때까지 해당 컴퓨터를 사용하여 결제하지 마세요. 잘못된 정보로 이체하시면 도움을 드릴 수 없습니다. 귀하의 계좌에서 자금이 인출되었는지 확인하십시오. 영수증이 확인되지 않으면 신청이 취소됩니다. 결제 시스템이나 은행에서 자금을 이체하는 데 지연이 발생할 수 있습니다. 이 경우 프로세스 속도를 높일 수 없으며 기다릴 수만 있습니다. 지연 이유를 알아보려면 전화를 걸거나 편지를 보내면 됩니다. 귀하의 결제 시스템이나 은행을 지원하십시오. 암호화폐로 결제 시, 주소, 사용 네트워크를 주의 깊게 확인하시고 당사 시스템에 대한 기타 리뷰를 고려하시기 바랍니다. 온라인에서 실수를 하면 우리에게 돈을 보내는 것이 아니라 아무데도 돈을 보내지 못하게 되며 우리는 당신을 도울 수 없습니다. 모든 이유는 개인적인 것입니다. 따라서 귀하의 이유가 위의 사항 중 하나가 아닌 경우 다음을 수행할 수 있습니다. 지원을 위해 당사에 편지를 보내십시오.",
        },
        faq7: {
          title:
            "신청상태가 '완료'로 변경되었으나 결제금액이 반영되지 않습니다. 어떻게 해야 하나요?",
          text: "결제 시스템이나 은행에서 자금을 이체하는 데 지연이 발생할 수 있습니다. 이 경우 프로세스 속도를 높일 수 없으며 기다릴 수만 있습니다. 지연 이유를 알아보려면 전화를 걸거나 편지를 보내면 됩니다. 귀하의 결제 시스템이나 은행을 지원하십시오. 암호화폐를 보낼 때도 시간이 걸립니다. 평균적으로 등록에는 3~6회의 네트워크 확인이 필요합니다. 자세한 내용은 귀하의 비트코인 ​​지갑이 어떤 서비스를 사용하고 있는지 확인할 수 있습니다. 확인 속도는 네트워크 부하와 커미션 규모에 따라 다릅니다. 수수료를 너무 낮게 설정하면 송금에 몇 시간 또는 그 이상이 걸릴 수 있습니다.",
        },
        faq8: {
          title: "신청을 취소할 수 있나요?",
          text: "사이트에서 생성된 모든 애플리케이션은 그대로 유지되며 삭제되지 않습니다. 상태만 변경할 수 있습니다. 시스템에는 4가지 상태만 있습니다: 새로 만들기 - 사용자만 애플리케이션을 생성했지만 사용자가 결제를 확인하지 않았습니다. 확인 중 - 사용자가 애플리케이션을 결제를 확인하고 대기 중입니다. 관리 부서의 확인 및 실행을 위해 완료 – 실제 교환이 완료된 후 애플리케이션이 이 상태로 진입합니다. 즉, 사용자의 세부 정보에 따라 자금이 지급됩니다. 취소됨 – 교환이 실행될 수 없는 경우 세부 사항이 잘못되었거나 기타 이유로 인해 웹사이트 관리팀에 의해 신청서가 이 상태로 이전됩니다. 또한 '새' 상태의 앱은 30분 후에 자동으로 이 상태로 전환됩니다. 신청서를 작성하면 신청서 확인 페이지로 이동됩니다. 결제 기한은 30분이며 신청 취소 버튼을 클릭하여 신청을 취소할 수 있습니다. 또한, 30분 이내에 아무런 조치가 없을 경우, 신청은 자동으로 취소됩니다. 물론, 완료된 지원서를 취소할 수는 없습니다.",
        },
        faq9: {
          title: "추가 환전 수수료가 있나요?",
          text: "모든 수수료는 환율에 포함되어 있습니다. 결제 시스템에 대한 수수료는 당사가 지불합니다. 실제 수령한 금액을 확인할 수 있습니다.",
        },
        faq10: {
          title: "하루에 몇 번까지 상환할 수 있나요?",
          text: "제한 없음.",
        },
      },
      terms: {
        term1: {
          title: "1. 참여권리",
          text: [
            "1.1. 귀하는 이에 동의하고 다음 사항을 확인합니다. 본 이용 약관을 수락할 수 있는 법적 연령에 도달했습니다. 귀하는 이전에 서비스 이용이 정지되거나 금지된 적이 없습니다.",
            "1.2. 귀하가 법인을 대신하여 서비스를 사용하는 경우 귀하는 다음 사항도 진술하고 보증합니다. 그 사람은 정당하게 등록되어 있고 그의 현행법에 따라 행동합니다. 법인 설립 관할권에 있으며 해당 법인은 귀하에게 그 법인을 대신하여 행동할 수 있는 권한을 부여했습니다.",
          ],
        },
        term2: {
          title: "2. 용어 및 정의",
          text: [
            "2.1. Changebit는 사용자에게 교환 기능을 제공하는 시스템의 상표입니다. 디지털 통화.",
            "2.2. 서비스 - 디지털 및/또는 전자 화폐의 교환, 판매 및 구매를 위한 인터넷 서비스를 제공하는 시스템입니다.",
            "2.3. 사용자는 Changebit 서비스를 사용하는 개인입니다.",
            "2.4. 디지털 통화 - 비트코인, 라이트코인, 이더리움 및 기타 블록체인 기반 통화.",
            "2.5. 결제 시스템은 다음을 대표하는 제3자가 개발한 소프트웨어 및 하드웨어 제품입니다. 금전적 의무를 설명하고 상호 합의를 조직하는 메커니즘입니다. 사용자에 의해.",
            "2.6. 서비스 - 구매, 판매 및 개인 간 P2P 거래 수행 지원 디지털 통화 교환 및 기타 서비스에 대한 정보가 서비스 창에 게시됩니다.",
            "2.7. 결제는 사용자로부터 사용자 또는 서비스로 디지털 통화 또는 법정화폐 자금을 이체하는 것입니다. 반대 방향.",
            "2.8. 신청 - 서비스가 제공하는 서비스 중 하나를 이용하고자 하는 사용자의 의사를 작성하여 표시하는 것 계약에 설명되고 매개변수에 지정된 조건에 따라 서비스 웹사이트를 통한 전자 양식 이 부록의.",
            "2.9. 파트너란 사용자 유치를 위한 서비스를 서비스에 제공하는 사람으로, 그 조건은 다음과 같습니다. 본 계약에서.",
          ],
        },
        term3: {
          title: "3. Changebit 웹사이트에서 계정을 사용하기 위한 규칙",
          text: [
            "3.1. Changebit 사이트는 개인적인 용도로만 사용됩니다. 사이트에 등록함으로써 귀하는 다음과 같은 행위를 하지 않을 것에 동의합니다. 자신의 계정이 아닌 다른 계정을 사용하고 승인되지 않은 계정을 얻으려고 시도하지 않습니다. 다른 사용자의 계정에 액세스합니다. ",
            "3.2. Changebit 관리팀은 제공된 정보를 추가로 확인하고 요청할 권리가 있습니다. 교환 관련 필수 서류 : 여권 사진 또는 기타 신분증 은행 카드(기밀 데이터 표시 없음) 자금 이체를 위한 현재 전화번호 영수증 및 기타 필요한 데이터. 음성인증도 가능합니다. (전화나 접속 가능한 메신저를 통해) 현재 전화번호와 연결됨). 서류 제출 조건이 충족되지 않는 경우 서비스는 거부할 권리가 있습니다. 서비스 제공을 중단하고 발송인의 계좌정보로 환불을 시작합니다. 반품 절차는 영업일 기준 최대 5일이 소요됩니다.",
            "3.3. Changebit 서비스는 사기를 방지하기 위해 거래를 중단하고 사용자의 자금을 보유할 권리가 있습니다. 필요한 기간 동안 서비스 또는 사용자의 재정적, 명예적 손실을 초래할 수 있는 행위 금융 조사를 수행하고 지불 게이트웨이 또는 발행자의 은행으로부터 거래 데이터를 얻기 위해.",
            "3.4. 귀하의 계정의 기밀성. 귀하는 엄격한 규정을 준수할 책임이 있음을 인정합니다. 비밀번호를 포함한 계정 정보를 기밀로 유지하고 디지털 통화를 보호합니다. 귀하의 계정에 게시된 모든 활동 및 거래에 대해. 귀하는 귀하와의 타협이 무엇이든 이해합니다. 로그인 정보는 귀하의 계정을 제3자의 무단 접근에 노출시킬 수 있으며, 이로 인해 연결된 은행 계좌와 같은 연결된 계좌를 포함하여 귀하의 계정에서 디지털 통화 또는 자금의 손실 또는 도난.",
            "3.5. 제3자에 대한 책임 귀하의 계정은 개인적인 용도로만 사용되며 악용할 수 없습니다. 또는 제3자에 의한 액세스. 어떠한 경우에도 귀하는 모든 작위 또는 부작위에 대해 전적인 책임을 집니다. 귀하의 계정에 액세스 및/또는 사용하는 제3자.",
            "3.6. 귀하는 범죄 행위를 포함하되 이에 국한되지 않는 범죄 행위에 가담하기 위해 서비스를 사용하지 않을 것에 동의합니다. 자금 세탁, 불법 도박, 테러 자금 조달. 또한 귀하는 방법을 사용하지 않을 것을 보증합니다. 귀하가 사이트에 액세스하는 위치를 숨기기 위해.",
          ],
        },
        term4: {
          title: "4. Changebit 웹사이트에서 제공되는 서비스",
          text: [
            "4.1. Changebit 서비스 주문은 사용자가 Changebit 인터넷 사이트를 통해 해당 애플리케이션을 전송함으로써 수행됩니다.",
            "4.2. 서비스를 이용함으로써 사용자는 자신이 지폐를 법적으로 소유하고 관리하고 있음을 확인합니다. 해당 결제와 관련된 전자 및/또는 디지털 화폐.",
            "4.3. Changebit 서비스는 다음과 같은 서비스를 제공합니다. 사용자에게 실시간으로 다른 사용자에게 전자 및/또는 디지털 또는 법정화폐를 판매할 수 있는 기회를 제공하는 서비스입니다. 사용자 간에 전자화폐와 디지털화폐를 상호 교환할 수 있는 기회를 제공하는 서비스입니다. 고객과 교환 서비스의 내부 준비금 간에 전자 및 디지털 통화를 상호 교환할 수 있는 기회를 사용자에게 제공하는 서비스입니다.",
            "4.4. 신청서를 작성함으로써 사용자는 지시하고 서비스는 사용자를 대신하여 사용자의 비용으로 디지털 및/또는 전자 제품의 판매 및 전송을 위한 조치를 수행합니다. 또는 법정화폐를 다른 사용자에게 양도할 수 있습니다.",
            "4.5. 사용자로부터 자금을 수령한 순간부터 규칙에 따라 할당된 시간(교환 방향에 따라) 동안 관련 조항에 지정된 금액 응용 프로그램, 서비스는 수신된 전자 또는 법정화폐를 사용자가 응용 프로그램에서 지정한 데이터 및 금액으로 전송(전송)할 의무가 있습니다. 불가항력적인 상황.",
            "4.6. 서비스는 해당 애플리케이션에 대한 결제가 이루어지지 않은 경우 디지털 및/또는 전자 또는 법정화폐 구매를 위해 사용자가 생성한 애플리케이션을 취소할 권리가 있습니다. 해당 애플리케이션이 생성된 후 30분 이내에 해당 서비스의 현재 계정으로 수신됩니다.",
            "4.7. 수신된 디지털 및/또는 전자 또는 법정화폐를 사용자에게 이체(이체)해야 하는 서비스의 의무는 인출 시점에 이행된 것으로 간주됩니다. 해당 결제 시스템의 거래 내역에 입력된 서비스 계정의 해당 결제 시스템의 디지털 및/또는 전자 또는 법정화폐.",
          ],
        },
        term5: {
          title: "5. 사용자 책임:",
          text: [
            "5.1. 사용자는 등록 시 제공한 정보와 데이터의 정확성과 완전성에 대한 책임이 있습니다. 이용자가 개인정보를 잘못 입력한 경우 응용 프로그램 실행을 위해 잘못된 데이터를 제공했거나 Changebit 서비스는 그러한 오류로 인해 사용자에게 발생한 손실에 대해 책임을 지지 않습니다.",
            "5.2. 이러한 조건에 동의하는 경우 사용자는 다음 사항을 솔직하게 선언하고 확인합니다.",
            "5.3. 그는 자신에 대해 정확하고 진실된 정보를 제공했습니다.",
            "5.4. 이들은 자금세탁 거래나 활동에 관여하지 않습니다.",
            "5.5. 그의 소득은 범죄 및/또는 테러 활동과 관련이 없습니다.",
            "5.6. 그의 소득은 다른 불법 활동과 관련이 없습니다.",
            "5.7. 사용자는 소프트웨어나 하드웨어를 방해하거나 서비스에 전송된 매개변수를 왜곡함으로써 Changebit 서비스의 운영을 방해하지 않을 것을 약속합니다.",
            "5.8. 불가항력이나 예상치 못한 사건으로 인해 본 약관을 준수하지 못한 부분적 또는 전체적 실패에 대해 사용자는 책임을 지지 않습니다. 또는 적절한 조치로 예방할 수 있습니다.",
          ],
        },
        term6: {
          title: "6. Заключительные положения",
          text: [
            "6.1. Changebit 서비스는 서비스 웹사이트에 변경 사항을 게시하여 계약을 일방적으로 변경할 권리가 있습니다. 변경사항은 그 순간부터 적용됩니다. 단, 변경 사항에 대한 다른 유효 날짜가 게시 시 추가로 결정되지 않는 한.",
            "6.2. Changebit는 사용자가 지정한 이메일을 통해 교환 프로세스 상태에 대한 정보 및 기타 정보를 사용자에게 보낼 권리가 있습니다.",
            "6.3. 모든 그래픽, 텍스트 정보, 프로그램 코드 등을 포함하여 사이트에 포함된 정보는 Changebit의 자산이며 저작권법에 의해 보호됩니다.",
            "6.4. 사용자는 본 약관의 모든 조항을 숙지하고 이를 완전히 수락함을 확인합니다.",
          ],
        },
      },
      dataServices: {
        dataServices1: {
          title: "암호화폐 시장 관리",
          text: "카드로 널리 사용되는 디지털 화폐를 인출하고 한 곳에서 손쉽게 관리하세요.",
        },
        dataServices2: {
          title: "강화된 보안 거래",
          text: "강화된 기밀 보호로 귀하의 자산을 보호하세요. 안전하고 시간 지연된 출금 프로세스를 통해 안심하고 거래하실 수 있습니다.",
        },
        dataServices3: {
          title: "이동 중에도 거래하세요",
          text: "Changebit 앱으로 언제 어디서나 거래하세요. 등록이 필요 없이 원활한 출금을 즐기세요. 단 몇 번의 클릭만으로 시장이나 은행 계좌에 들어갈 수 있습니다.",
        },
      },
      dataCryptoTab: {
        dataCryptoTab1: {
          title: "교환 제출",
        },
        dataCryptoTab2: {
          title: "지불 확인서",
        },
        dataCryptoTab3: {
          title: "교환 세부정보",
        },
      },
      productLink: {
        productLink1: {
          title: "메인 페이지",
        },
        productLink2: {
          title: "교환",
        },
        productLink3: {
          title: "시장",
        },
        productLink4: {
          title: "총 공급량",
        },
        productLink5: {
          title: "자주 묻는 질문",
        },
      },
      servicesLink: {
        servicesLink1: {
          title: "등록하다",
        },
        servicesLink2: {
          title: "로그인",
        },
        servicesLink3: {
          title: "개인 정보 정책",
        },
        servicesLink4: {
          title: "이용 약관",
        },
      },
      dataCoinTab: {
        dataCoinTab1: {
          title: "유저 프로필",
        },
        dataCoinTab2: {
          title: "추천",
        },
        dataCoinTab3: {
          title: "업무",
        },
        dataCoinTab4: {
          title: "비밀번호 변경",
        },
      },
      dataAbout: {
        dataAbout1: {
          title: "익명",
          text: "Changebit로 개인정보를 보호하세요. 거래 세부정보와 해시는 이메일을 통해 전송되므로 고객에게만 공개되고 거래의 기밀이 유지됩니다.",
        },
        dataAbout2: {
          title: "신뢰",
          text: "Changebit에서 안심하고 거래하세요. 우리는 경쟁력 있는 가격을 제공하여 귀하가 거래에 대한 가치를 얻을 수 있도록 보장합니다. 당사의 시장 데이터는 지속적으로 최신 상태를 유지하여 귀하의 거래 결정에 신뢰할 수 있는 정보를 제공합니다.",
        },
        dataAbout3: {
          title: "지역 사회",
          text: "우리는 중요한 데이터와 정보가 가장 필요한 사람들이 접근할 수 있도록 암호화폐 커뮤니티를 지원하기 위해 최선을 다하고 있습니다.",
        },
      },
      dataWork: {
        dataWork1: {
          step: "1 단계",
          title: "교환 페이지로 이동",
          text: "바로 여기를 클릭하세요 ☝️",
        },
        dataWork2: {
          step: "2 단계",
          title: "교환 제출",
          text: "양식의 모든 필드를 채우십시오. 귀하의 주소 네트워크에 주의하세요",
        },
        dataWork3: {
          step: "3 단계",
          title: "해당 주소로 자금을 보내세요",
          text: "QR 코드를 클릭하고 거래소 주소로 자산을 보내세요. 네트워크에도 주목하세요.",
        },
        dataWork4: {
          step: "4 단계",
          title: "금액을 받아보세요!",
          text: "결제가 완료되면 즉시 귀하의 지갑으로 통화를 보내드립니다. 모든 세부정보를 확인하세요!",
        },
      },
      dataPrivacy: {
        dataPrivacy1: {
          title: "1. 귀하가 당사에 제공하는 정보:",
          text: "당사는 귀하가 당사 웹사이트에 입력하거나 다른 방식으로 당사에 제공하는 모든 정보를 수신하고 저장합니다. 귀하는 특정 정보를 제공하지 않도록 선택할 수 있지만, 그럴 경우 당사의 많은 기능을 활용하지 못할 수도 있습니다. 당사는 귀하의 요청에 응답하고, 향후 쇼핑을 맞춤화하고, 매장을 개선하고, 귀하와 소통하는 등의 목적으로 귀하가 제공한 정보를 사용합니다.",
        },
        dataPrivacy2: {
          title: "2. 자동 정보:",
          text: "We receive and store certain types of information whenever you interact with us. For example, like many web sites, we use cookies and we obtain certain types of information when your web browser accesses Changebit. Scroll to the bottom of this page to see examples of the information we receive. A number of companies offer utilities designed to help you visit web sites anonymously. Although we will not be able to provide you with a personalised experience at Changebit if we cannot recognise you, we want you to be aware that these tools exist.",
        },
        dataPrivacy3: {
          title: "3. 쿠키는 어떻습니까?",
          text: "당사가 수집하고 분석하는 정보의 예로는 귀하의 컴퓨터를 인터넷에 연결하는 데 사용되는 인터넷 프로토콜(IP) 주소가 있습니다. 로그인; 이메일 주소; 비밀번호; 브라우저 유형 및 버전, 운영 체제 및 플랫폼과 같은 컴퓨터 및 연결 정보 구매 내역; 날짜와 시간을 포함하여 당사 웹사이트를 통과하고 당사 웹사이트를 통과하는 전체 URL(Uniform Resource Locator) 클릭스트림, 쿠키번호; 귀하가 보거나 검색한 제품.",
        },
        dataPrivacy4: {
          title: "4. 이메일 커뮤니케이션:",
          text: "이메일을 더욱 유용하고 흥미롭게 만들기 위해 귀하가 Changebit에서 이메일을 열 때 귀하의 컴퓨터가 이러한 기능을 지원하는지 확인하는 경우가 종종 있습니다. 당사로부터 이메일이나 기타 메일을 받고 싶지 않으시면 뉴스레터 메뉴에서 구독 취소를 선택하여 이를 반영하도록 계정을 조정하시기 바랍니다.",
        },
        dataPrivacy5: {
          title: "5. Changebit는 수신한 정보를 공유합니까?",
          text: "고객에 대한 정보는 우리 사업의 중요한 부분이며, 우리는 이를 다른 사람에게 판매하는 사업을 하지 않습니다.",
        },
      },
      // other translations...
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // default language
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
